import { DefaultFooter } from '@ant-design/pro-layout';
import { useIntl } from 'umi';
import axios from "@/utils/axios";
import {notification} from "antd";
import data from "@/utils/data";
import {history} from "@@/core/history";
import { useEffect } from 'react';

export default () => {
  const intl = useIntl();
  useEffect(() => {
    axios.interceptors.response.use(
      (response) =>
        // Do something with response data
        response,
      (error) => {
        console.log(error);
        switch (error?.response?.status) {
          case 400: {
            notification.error({
              message: intl.formatMessage({id: 'common.messages.errors.coLoiXayRa'}),
              description:
                data.error[
                error?.response?.data?.detail?.errorCode || error?.response?.data?.errorCode
                  ] ||
                error?.response?.data?.errorDescription ||
                error?.data?.detail?.message ||
                error?.message,
            });
            break;
          }

          case 401:
            notification.error({
              message: 'Vui lòng đăng nhập lại',
              description: '',
            });
            localStorage.removeItem('vaiTro');
            localStorage.removeItem('token');
            history.replace({
              pathname: '/user/login',
            });
            break;

          case 404:
            notification.error({
              message:
                'Lỗi không tìm thấy dữ liệu, bạn hãy thử f5 refresh lại trình duyệt để cập nhật phiên bản mới nhất.',
              description: error?.response?.data?.detail?.message || error?.message,
            });
            break;

          case 405:
            notification.error({
              message: 'Truy vấn không được phép',
              description: error?.response?.data?.detail?.message || error?.message,
            });
            break;

          case 409:
            notification.error({
              message: 'Dữ liệu chưa đúng',
              description: error?.response?.data?.detail?.message || error?.message,
            });
            break;

          case 500:
            notification.error({
              message: 'Server gặp lỗi',
              description: error?.response?.data?.detail?.message || error.message,
            });
            break;

          default:
            break;
        }
        return Promise.reject(error);
      },
      // Do something with response error
    );
  },[intl])
  const defaultMessage = intl.formatMessage({
    id: 'app.copyright.produced',
    defaultMessage: 'CopyRight',
  });

  return (
    <DefaultFooter
      copyright={`2021 ${defaultMessage}`}
      links={
        [
          // {
          //   key: 'github',
          //   title: 'Học viện Công nghệ Bưu Chính Viễn thông',
          //   href: 'https://portal.ptit.edu.vn/',
          //   blankTarget: true,
          // },
        ]
      }
    />
  );
};
